import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-home" */ `./views/Home.vue`),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Home',
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Configurações',
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
    {
        path: `/${apiConstants.code}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pugestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pugestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pugestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pugestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camadas',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Camadas',
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-regulation" */ './views/regulation/RegulationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.regulations`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-regulation" */ './views/regulation/RegulationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamentos',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.regulations.create`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'item'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.regulations.show.group`,
                // props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'item/:id',
                name: `${apiConstants.code}.regulations.show.item`,
                // props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Regulamentos',
        }
    },
    {
        path: `/${apiConstants.code}/lotusetypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-lotusetypes" */ './views/lotusetypes/LotUseTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.lot_use_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-lotusetypes" */ './views/lotusetypes/LotUseTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `lot_use_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.lot_use_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-lotusetypes" */ './views/lotusetypes/LotUseTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `lot_use_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.lot_use_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-lotusetypes" */ './views/lotusetypes/LotUseTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `lot_use_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `lot_use_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/equipmenttypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-equipmenttypes" */ './views/equipmenttypes/EquipmentTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.equipment_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-equipmenttypes" */ './views/equipmenttypes/EquipmentTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `equipment_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.equipment_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-equipmenttypes" */ './views/equipmenttypes/EquipmentTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `equipment_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.equipment_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-equipmenttypes" */ './views/equipmenttypes/EquipmentTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `equipment_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `equipment_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/greenspacetypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-greenspacetypes" */ './views/greenspacetypes/GreenSpaceTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.green_space_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-greenspacetypes" */ './views/greenspacetypes/GreenSpaceTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `green_space_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.green_space_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-greenspacetypes" */ './views/greenspacetypes/GreenSpaceTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `green_space_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.green_space_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-greenspacetypes" */ './views/greenspacetypes/GreenSpaceTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `green_space_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `green_space_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licensefiletypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensefiletypes" */ './views/licensefiletypes/LicenseFileTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_file_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensefiletypes" */ './views/licensefiletypes/LicenseFileTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_file_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_file_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensefiletypes" */ './views/licensefiletypes/LicenseFileTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_file_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_file_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensefiletypes" */ './views/licensefiletypes/LicenseFileTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_file_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_file_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licensestatuses`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensestatuses" */ './views/licensestatuses/LicenseStatusBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_statuses`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensestatuses" */ './views/licensestatuses/LicenseStatusList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_statuses.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_statuses.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensestatuses" */ './views/licensestatuses/LicenseStatusDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_statuses.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_statuses.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensestatuses" */ './views/licensestatuses/LicenseStatusDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_statuses.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_statuses.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licensetypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensetypes" */ './views/licensetypes/LicenseTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensetypes" */ './views/licensetypes/LicenseTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title:  `license_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensetypes" */ './views/licensetypes/LicenseTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licensetypes" */ './views/licensetypes/LicenseTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licenseusetypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseusetypes" */ './views/licenseusetypes/LicenseUseTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_use_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseusetypes" */ './views/licenseusetypes/LicenseUseTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_use_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_use_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseusetypes" */ './views/licenseusetypes/LicenseUseTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_use_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_use_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseusetypes" */ './views/licenseusetypes/LicenseUseTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_use_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_use_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/places`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-places" */ './views/places/PlaceBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.places`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-places" */ './views/places/PlaceList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `places.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.places.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-places" */ './views/places/PlaceDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `places.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.places.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-places" */ './views/places/PlaceDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `places.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `places.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licenseowners`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseowners" */ './views/licenseowners/LicenseOwnerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_owners`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseowners" */ './views/licenseowners/LicenseOwnerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_owners.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_owners.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseowners" */ './views/licenseowners/LicenseOwnerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_owners.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_owners.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseowners" */ './views/licenseowners/LicenseOwnerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_owners.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_owners.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licenseguaranteeowners`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteeowners" */ './views/licenseguaranteeowners/LicenseGuaranteeOwnerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_guarantee_owners`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteeowners" */ './views/licenseguaranteeowners/LicenseGuaranteeOwnerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_owners.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_guarantee_owners.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteeowners" */ './views/licenseguaranteeowners/LicenseGuaranteeOwnerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_owners.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_guarantee_owners.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteeowners" */ './views/licenseguaranteeowners/LicenseGuaranteeOwnerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_owners.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_guarantee_owners.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licenseguaranteetypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteetypes" */ './views/licenseguaranteetypes/LicenseGuaranteeTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_guarantee_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteetypes" */ './views/licenseguaranteetypes/LicenseGuaranteeTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_guarantee_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteetypes" */ './views/licenseguaranteetypes/LicenseGuaranteeTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_guarantee_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteetypes" */ './views/licenseguaranteetypes/LicenseGuaranteeTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_guarantee_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/licenseguaranteestates`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteestates" */ './views/licenseguaranteestates/LicenseGuaranteeStateBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.license_guarantee_states`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteestates" */ './views/licenseguaranteestates/LicenseGuaranteeStateList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_states.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.license_guarantee_states.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteestates" */ './views/licenseguaranteestates/LicenseGuaranteeStateDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_states.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.license_guarantee_states.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-licenseguaranteestates" */ './views/licenseguaranteestates/LicenseGuaranteeStateDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `license_guarantee_states.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `license_guarantee_states.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/titletypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-titletypes" */ './views/titletypes/TitleTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.title_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-titletypes" */ './views/titletypes/TitleTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `title_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.title_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-titletypes" */ './views/titletypes/TitleTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `title_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.title_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-titletypes" */ './views/titletypes/TitleTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `title_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `title_types.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/proceduretypes`,
        component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-proceduretypes" */ './views/proceduretypes/ProcedureTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.procedure_types`,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-proceduretypes" */ './views/proceduretypes/ProcedureTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `procedure_types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.procedure_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-proceduretypes" */ './views/proceduretypes/ProcedureTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `procedure_types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.procedure_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /*webpackChunkName: "pugestao-proceduretypes" */ './views/proceduretypes/ProcedureTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `procedure_types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `procedure_types.titles`,
        }
    },


];

export default routes;
